// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"f7f34eb0","239":"4a3ce17f","469":"33b8bfdd"}[chunkId] + ".chunk.js";
};